.backdrop {
  position: fixed;
  inset: 0;
  z-index: 60;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.backdrop::before {
  content: "";
  position: absolute;
  inset: 0;
  background: var(--ink);
  opacity: 0.34;
}

.dialog {
  position: relative;
  display: flex;
  flex-direction: column;
  width: min(100%, 800px);
  max-height: 100%;
  min-height: 0;
  background: var(--panel);
  color: var(--ink);
  border-radius: var(--radius);
  box-shadow: var(--shadow-drawer);
  font-size: var(--t-dense);
  line-height: 1.6;
}

.header {
  display: flex;
  align-items: start;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 20px;
  border-bottom: 1px solid var(--line);
}

.header h2 {
  margin: 0;
  font-size: var(--t-head);
  overflow-wrap: anywhere;
}

.body {
  overflow-y: auto;
  padding: 0 20px 20px;
  overscroll-behavior: contain;
}

.body p {
  max-width: 72ch;
}

.body h3 {
  margin: 24px 0 8px;
  font-size: var(--t-head);
}

.history {
  padding-left: 24px;
}

.version {
  padding: 10px 0;
  border-bottom: 1px solid var(--line);
}

.version p {
  margin: 4px 0;
}

.identifier {
  overflow-wrap: anywhere;
}

.fields {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 230px), 1fr));
  gap: 14px;
  margin: 0 0 14px;
  padding: 0;
  border: 0;
}

.full {
  grid-column: 1 / -1;
}

/* A field and the sentence under it share one grid cell. Without this the cell's spare height is
   spread over its rows, so a field whose neighbour is showing a sentence sits lower than it. */
.cell {
  align-content: start;
}

.review {
  padding-top: 8px;
  margin-top: 16px;
  border-top: 1px solid var(--line);
}

.dialog button:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 3px;
}

@media (width <= 600px) {
  .backdrop {
    padding: 8px;
  }

  .header {
    padding: 12px;
  }

  .body {
    padding: 0 12px 16px;
  }
}
